<script lang="jsx">
import '@css/fonts.css'
import '@css/style.css'

import { ref, reactive, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { login as loginApi } from '@api'

import { useAuthStore } from '@store/pinia/auth.store.js'
import { watchersAction, watchersSetter } from '@store/watchers.js'

export default {
  name: 'Wrapper',

  setup() {
    // остальной твой state
    const searchType = ref('user')
    const saveList = ref([])
    const competitonId = ref(7427)
    const resultList = ref([])
    const searchValue = ref('')
    const competitons = ref([{ id: 7427, name: 'ROC' }])
    const activeData = reactive({})
    const groups = reactive({})

    const route = useRoute()
    watch(
      () => route.fullPath,
      () => window.scrollTo(0, 0)
    )

    const auth = useAuthStore()
    const isLoggedIn = computed(() => Boolean(auth?.token || auth?.user))
    const login = ref('')
    const password = ref('')
    const loginDialog = ref(null)
    const loginError = ref('')
    const loginPending = ref(false)
    const showPassword = ref(false)
    const loginInputRef = ref(null)

    const openLogin = () => {
      if (isLoggedIn.value || !loginDialog.value) return
      loginError.value = ''
      password.value = ''
      showPassword.value = false
      if (typeof loginDialog.value.showModal === 'function') {
        loginDialog.value.showModal()
      } else {
        loginDialog.value.show()
      }
      setTimeout(() => {
        loginInputRef.value?.focus?.()
      }, 0)
    }

    const closeLogin = (clearPendingWatcher = true) => {
      loginDialog.value?.close?.()
      loginPending.value = false
      if (clearPendingWatcher) {
        auth.clearPendingWatcher()
      }
    }

    const submitLogin = async event => {
      event.preventDefault()
      if (loginPending.value) return

      const nextLogin = String(login.value || '').trim()
      const nextPassword = String(password.value || '')
      if (!nextLogin || !nextPassword) {
        loginError.value = 'Введите логин и пароль'
        return
      }

      loginPending.value = true
      loginError.value = ''

      try {
        const data = await loginApi(nextLogin, nextPassword)
        auth.setAuth(data)
        await watchersAction.syncWatchersWithServer()
        const pendingWatcher = auth.consumePendingWatcher()
        if (pendingWatcher) {
          await watchersSetter.addWatchers(pendingWatcher)
        }
        closeLogin(false)
      } catch (error) {
        loginError.value =
          error?.response?.data?.error ||
          error?.message ||
          'Не удалось выполнить вход'
      } finally {
        loginPending.value = false
      }
    }

    watch(
      () => auth.loginRequestId,
      () => openLogin()
    )

    return () => {
      return (
        <div class='app-layout'>
          <header class='auth-nav'>
            <nav class='auth-nav__list'>
              {isLoggedIn.value ? (
                <>
                <router-link to='/' class='auth-nav__link'>
                  Main
                </router-link>
                <router-link to='/tournaments/' class='auth-nav__link'>
                  Tournaments
                </router-link>
                <router-link to='/system' class='auth-nav__link'>
                  System
                </router-link>
                <router-link to='/clients' class='auth-nav__link'>
                  Clients
                </router-link>
                <router-link to='/bookings/' class='auth-nav__link'>
                  Bookings
                </router-link>
                </>
              ) : (
                <button class='auth-nav__link' type='button' onClick={openLogin}>
                  Login
                </button>
              )}
            </nav>
          </header>

          <dialog
            class='login-form'
            ref={element => {
              loginDialog.value = element
            }}
            onCancel={event => {
              event.preventDefault()
              closeLogin()
            }}
          >
            <form class='login-form__content' onSubmit={submitLogin}>
              <div class='login-form__title'>Вход в аккаунт</div>
              <div class='login-form__subtitle'>
                Используйте email и пароль учетной записи.
              </div>

              <label class='login-field'>
                <span class='login-field__label'>Логин / Email</span>
                <input
                  ref={element => {
                    loginInputRef.value = element
                  }}
                  value={login.value}
                  onInput={event => {
                    login.value = event.target.value
                  }}
                  class='login-input'
                  type='email'
                  autocomplete='username'
                  placeholder='example@mail.com'
                />
              </label>

              <label class='login-field'>
                <span class='login-field__label'>Пароль</span>
                <div class='login-password-wrap'>
                  <input
                    value={password.value}
                    onInput={event => {
                      password.value = event.target.value
                    }}
                    class='login-input'
                    type={showPassword.value ? 'text' : 'password'}
                    autocomplete='current-password'
                    placeholder='Введите пароль'
                  />
                  <button
                    type='button'
                    class='login-password-toggle'
                    onClick={() => {
                      showPassword.value = !showPassword.value
                    }}
                  >
                    {showPassword.value ? 'Скрыть' : 'Показать'}
                  </button>
                </div>
              </label>

              {loginError.value ? (
                <div class='login-error'>{loginError.value}</div>
              ) : null}

              <div class='login-row login-row--actions'>
                <button
                  onClick={() => closeLogin()}
                  class='button login-btn login-btn--secondary'
                  type='button'
                  disabled={loginPending.value}
                >
                  Отмена
                </button>
                <button
                  class='button button--blue login-btn'
                  type='submit'
                  disabled={loginPending.value}
                >
                  {loginPending.value ? 'Входим...' : 'Войти'}
                </button>
              </div>
            </form>
          </dialog>

          <router-view name='body' />
        </div>
      )
    }
  }
}
</script>
